import React, { memo, useMemo } from "react";
import SeccionProductosHorizontal from "./SeccionProductosHorizontal";

function AcordeonCategoria({
  seccionNombre,
  productosSeccion = [],
  abierta = false,
  onToggle,
  logoNegocio,
  onAbrirProducto,
  favoritosIds = [],
  onToggleFavorito,
  categoriaRef,
}) {
  const productoImagenCategoria = useMemo(() => {
    return productosSeccion.find(
      (producto) =>
        producto.imagen &&
        !producto.imagen.includes("placeholder") &&
        producto.imagen.startsWith("http"),
    );
  }, [productosSeccion]);

  const precioMasBajoCategoria = useMemo(() => {
    return productosSeccion.reduce((menor, producto) => {
      const precio = Number(producto.precio);

      if (!Number.isFinite(precio)) return menor;

      return menor === null || precio < menor ? precio : menor;
    }, null);
  }, [productosSeccion]);

  const productoDestacadoCategoria = useMemo(() => {
    return (
      productosSeccion.find((producto) => producto.disponible !== false) ||
      productosSeccion[0]
    );
  }, [productosSeccion]);

  const etiquetaDestacado = productoDestacadoCategoria?.esMasPedido
    ? "Lo más pedido"
    : "Nuestra sugerencia";

  return (
    <div
      ref={categoriaRef}
      style={{
        scrollMarginTop: "78px",
        marginBottom: "12px",
        backgroundColor: "#fff",
        borderRadius: "18px",
        border: abierta ? "1px solid #111" : "1px solid #ececec",
        overflow: "hidden",
        boxShadow: abierta
          ? "0 10px 24px rgba(0,0,0,.08)"
          : "0 2px 8px rgba(0,0,0,.03)",
        transition: "all .25s ease",
      }}
    >
      <button
        type="button"
        onClick={onToggle}
        onMouseEnter={(e) => {
          e.currentTarget.style.background =
            "linear-gradient(180deg,#ffffff,#f5f5f5)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background =
            "linear-gradient(180deg,#ffffff,#fafafa)";
        }}
        style={{
          width: "100%",
          border: "none",
          background: "linear-gradient(180deg,#ffffff,#fafafa)",
          padding: "16px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          cursor: "pointer",
          textAlign: "left",
          gap: "14px",
          transition: "background .25s ease",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
          }}
        >
          {productoImagenCategoria && (
            <img
              src={productoImagenCategoria.imagen}
              alt={seccionNombre}
              loading="lazy"
              decoding="async"
              style={{
                width: "52px",
                height: "52px",
                borderRadius: "14px",
                objectFit: "cover",
                flexShrink: 0,
                border: "2px solid #fff",
                boxShadow: "0 4px 10px rgba(0,0,0,.12)",
              }}
            />
          )}

          <div>
            <div
              style={{
                fontSize: "15px",
                fontWeight: "900",
              }}
            >
              {seccionNombre}
            </div>

            <div
              style={{
                fontSize: "11px",
                color: "#777",
                marginTop: "2px",
              }}
            >
              {precioMasBajoCategoria !== null
                ? `Desde $${precioMasBajoCategoria} · ${productosSeccion.length} productos`
                : `${productosSeccion.length} productos`}
            </div>

            {productoDestacadoCategoria && (
              <div
                style={{
                  marginTop: "8px",
                  padding: "7px 10px",
                  backgroundColor:
                    etiquetaDestacado === "Lo más pedido"
                      ? "#fff7e6"
                      : "#f7f7f7",
                  borderRadius: "10px",
                  display: "inline-flex",
                  flexDirection: "column",
                  gap: "2px",
                  maxWidth: "100%",
                }}
              >
                <span
                  style={{
                    fontSize: "10px",
                    fontWeight: "900",
                    color:
                      etiquetaDestacado === "Lo más pedido"
                        ? "#d97706"
                        : "#6b7280",
                    textTransform: "uppercase",
                    letterSpacing: ".6px",
                  }}
                >
                  {etiquetaDestacado}
                </span>

                <span
                  style={{
                    fontSize: "12px",
                    fontWeight: "800",
                    color: "#111",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {productoDestacadoCategoria.nombre}
                </span>
              </div>
            )}
          </div>
        </div>

        <div
          style={{
            width: "34px",
            height: "34px",
            borderRadius: "50%",
            backgroundColor: abierta ? "#111" : "#f3f3f3",
            color: abierta ? "#fff" : "#666",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transition: "all .25s ease",
            flexShrink: 0,
          }}
        >
          <span
            style={{
              fontSize: "18px",
              fontWeight: "900",
              transform: abierta ? "rotate(180deg)" : "rotate(0deg)",
              transition: "transform .25s ease",
            }}
          >
            ⌄
          </span>
        </div>
      </button>

      <div
        style={{
          display: "grid",
          gridTemplateRows: abierta ? "1fr" : "0fr",
          transition: "grid-template-rows .35s ease",
        }}
      >
        <div
          style={{
            overflow: "hidden",
            opacity: abierta ? 1 : 0,
            transition: "opacity .25s ease",
            padding: abierta ? "6px 0 14px 0" : "0",
          }}
        >
          <SeccionProductosHorizontal
            titulo=""
            subtitulo=""
            productos={productosSeccion}
            logoNegocio={logoNegocio}
            onAbrirProducto={onAbrirProducto}
            mostrarBotonFavorito
            favoritosIds={favoritosIds}
            onToggleFavorito={onToggleFavorito}
          />
        </div>
      </div>
    </div>
  );
}

export default memo(AcordeonCategoria);
